const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

const toQuery = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    params.set(key, value);
  });
  return params.toString();
};

const request = async (path) => {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: { 'Content-Type': 'application/json' },
  });
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const payload = await res.json();
      detail = payload?.detail || detail;
    } catch (_e) {
      // ignore
    }
    throw new Error(detail);
  }
  return res.json();
};

export const fetchAuditLogs = async (filters = {}) => {
  const query = toQuery(filters);
  return request(`/api/audit/logs${query ? `?${query}` : ''}`);
};

export const fetchEntityAuditHistory = async (entityType, entityId, limit = 200) =>
  request(`/api/audit/${encodeURIComponent(entityType)}/${encodeURIComponent(entityId)}?limit=${limit}`);
